import React, { FC } from "react";

import { Hidden } from "@mui/material";

import { Check, Dot } from "@/assets/icons/index";

import { StyledProgressBar } from "./styled";

type ProgressBarProps = {
    startLabel?: string;
    endLabel?: string;
    steps?: number;
    currentStep?: number;
};

const ProgressBar: FC<ProgressBarProps> = ({ startLabel, endLabel, steps, currentStep }) => {
    const progressWidth = ((currentStep + 1) * 100) / steps;
    const completeInfo = () => {
        if (currentStep === steps - 1) {
            return <Check />;
        }
        return <Dot />;
    };

    return (
        <StyledProgressBar role="progressbar" aria-valuenow={currentStep} aria-valuemin={0} aria-valuemax={steps}>
            <div className="progressbar-layout">
                <Hidden smDown>
                    <Check />
                </Hidden>
                <div className="bar-layout">
                    <div className="filler" style={{ width: `${progressWidth}%` }} />
                </div>
                <Hidden smDown>{completeInfo()}</Hidden>
            </div>
            <div className="label-container">
                <span>{startLabel}</span>
                <span>{endLabel}</span>
            </div>
        </StyledProgressBar>
    );
};

export default ProgressBar;
